import React from 'react';
import { useStyletron } from 'baseui';
import { PLACEMENT, StatefulPopover } from 'baseui/popover';
import { useSnackbar } from 'baseui/snackbar';
import { useAtomValue, useSetAtom } from 'jotai';
import ToolbarButton from '../../../../common/toolbar-button';
import { LONG_TOAST_DURATION } from '../../../../modernization-common/side-panel/const';
import PolygonIcon from '../../../labelling/components/annotations/polygon/config/icon';
import PolylineIcon from '../../../labelling/components/annotations/polyline/config/icon';
import { TOOL_CONFIG } from '../../../labelling/components/toolbar/constants';
import { CUSTOM_TOOLS, TOOL } from '../../../labelling/constants';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../atoms/label-store-dispatch/events';
import { selectedAnnotationLabelAtom, selectedToolAtom } from '../../atoms/tool-atoms';
export const ToolSelectorControl = () => {
  const [css, theme] = useStyletron();
  const selectedLabel = useAtomValue(selectedAnnotationLabelAtom);
  const selectedTool = useAtomValue(selectedToolAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const {
    enqueue
  } = useSnackbar();
  const validTools = selectedLabel?.tools;
  if (!selectedLabel) {
    return;
  }
  if (validTools?.length === 1) {
    return;
  }
  const SelectedIcon = TOOL_CONFIG[selectedTool].Icon;
  return <StatefulPopover placement={PLACEMENT.bottom} showArrow content={({
    close
  }) => {
    const iconList = (selectedLabel.tools ?? Object.values(TOOL)).map(tool => {
      if (tool === TOOL.POINTER || tool === TOOL.SNAP || tool === TOOL.GRID || tool === CUSTOM_TOOLS.FRAME_CLASSIFICATION) {
        return;
      }
      const Icon = TOOL_CONFIG[tool].Icon;
      return <ToolbarButton key={tool} title={TOOL_CONFIG[tool].title} onClick={() => {
        dispatch({
          type: EVENTS.SELECT_TOOL,
          tool
        });
        if (tool === TOOL.POLYGON) {
          enqueue({
            message: 'Click on the starting dot again to close the polygon.',
            startEnhancer: () => <PolygonIcon />
          }, LONG_TOAST_DURATION);
        }
        if (tool === TOOL.POLYLINE) {
          enqueue({
            message: 'Double-click to finish drawing the polyline.',
            startEnhancer: () => <PolylineIcon />
          }, LONG_TOAST_DURATION);
        }
        close();
      }}>
              <Icon title={tool} />
            </ToolbarButton>;
    });
    return <div className={css({
      padding: theme.sizing.scale100,
      backgroundColor: theme.colors.backgroundPrimary,
      borderRadius: theme.borders.popoverBorderRadius
    })}>
            {iconList}
          </div>;
  }} returnFocus autoFocus>
      <ToolbarButton title="Select tool">
        <SelectedIcon strokeColor={selectedLabel.style.strokeColor} title="Select tool" />
      </ToolbarButton>
    </StatefulPopover>;
};